export const extractLoginPrefix = (loginName) => {
  const normalizedLoginName = `${loginName || ""}`.trim();
  const separatorIndex = normalizedLoginName.indexOf("-");

  if (separatorIndex <= 0) {
    return "";
  }

  return normalizedLoginName.slice(0, separatorIndex);
};

export const stripLoginPrefix = (loginName, prefix) => {
  const normalizedLoginName = `${loginName || ""}`.trim();
  const normalizedPrefix = `${prefix || ""}`.trim();
  const prefixedValue = normalizedPrefix ? `${normalizedPrefix}-` : "";

  if (prefixedValue && normalizedLoginName.startsWith(prefixedValue)) {
    return normalizedLoginName.slice(prefixedValue.length);
  }

  return normalizedLoginName;
};
